import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav/nav.component';
export class CoreModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [NavComponent],
  exports: [
    NavComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CoreModule_tsickle_Closure_declarations() {
/** @type {?} */
CoreModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CoreModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
